document.addEventListener("DOMContentLoaded", () => {
  const content = document.querySelector(".custom-content-js"),
    toc = document.querySelector(".table_of_contents");
  if (!content || !toc) {
    console.warn("ERROR .table_of_contents");
    return;
  }
  const headings = content.querySelectorAll("h2, h3, h4, h5, h6"),
    tocList = document.createElement("ul");
  headings.forEach((heading, index) => {
    heading.id || (heading.id = `heading-${index}`);
    const listItem = document.createElement("li");
    listItem.style.marginLeft = `${(parseInt(heading.tagName[1]) - 2) * 15}px`;
    const link = document.createElement("a");
    (link.href = `#${heading.id}`),
      (link.textContent = heading.innerText.trim()),
      listItem.appendChild(link),
      tocList.appendChild(listItem);
  }),
    toc.appendChild(tocList);

  const tableBtn = document.querySelector(".custom-blog__table__top");

  tableBtn.addEventListener("click", () => {
    toc.classList.toggle("close");
    tableBtn.classList.toggle("active");
  });
});
